// extracted by mini-css-extract-plugin
export default {"card":"SystemManagementInfoCard_card__wSPc0","sectionContent":"SystemManagementInfoCard_sectionContent__0Tgkw"};